/*
 * Public API Surface of count-up
 */

export * from './lib/count-up.module';
export * from './lib/count-up.directive';